/* eslint-disable */
import {FC} from "react";
import {Box, Card, CardContent, Grid, Typography} from "@material-ui/core";
import cashIcon from "../../../../../assets/icons/ventasTotalesIcon.svg";
import {CurrencyFormatter} from "../Utils/CurrencyFormatter";
import {useStyles} from "../../style";

const TotalSalesIncome: FC<any> = (props) => {
    const { data } = props;
    const classes = useStyles();
    const values = data;

    return (
        <Grid container alignItems="stretch">
            <Grid className={classes.mainChartGrid} item component={Card} xs>
                <CardContent style={{padding: '18px 20px'}}>
                    <Box className={classes.containerTitles}>
                        <Box mr={1}>
                            <img src={cashIcon} alt="cashIcon" width="35px" height="35px" />
                        </Box>
                        <Typography className={classes.chartBarDonutTitle}>
                            Ingreso por Ventas Totales
                        </Typography>
                    </Box>
                    <Box className={classes.containerBoxCashAvailable}>
                        <Box className={classes.textCashAvaible}>
                            <Typography
                                className={classes.textSecondary}
                            >
                                <CurrencyFormatter value={values}/>
                            </Typography>
                        </Box>
                    </Box>
                </CardContent>
            </Grid>
        </Grid>
    )
};

export default TotalSalesIncome;